export const isAppReviewer = (email) => {
  if (!email) return false;
  return /appreview[0-9]*@apple.com/.test(email);
};
